<template>
    <button
        type="button"
        class="flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-200 border border-primary-emphasis/20 dark:border-white/20 text-primary-emphasis dark:text-white/80 hover:bg-primary-emphasis/10 dark:hover:bg-white/10 hover:border-primary-emphasis/40 dark:hover:border-white/40 active:scale-95"
        @click="toggleDark"
    >
        <span class="text-base leading-none">{{ isDark ? "🌞" : "🌛" }}</span>
        <span>{{ isDark ? "Light" : "Dark" }}</span>
    </button>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";

import { useControlStore } from "@/stores/control";

const { isDark } = storeToRefs(useControlStore());
const { toggleDark } = useControlStore();
</script>
